import React, { useState,useEffect} from 'react';
import { VegaFlex, VegaIcon } from "@heartlandone/vega-react";
import ReactPlayer from 'react-player'

const Carousel = (props) => {
  const { direction = 'row', height = 670, urls: { videos = [], images = [] } } = props;
  const [main, setMain] = useState(images[0]);
  const [currentVideoSrc, setCurrentVideoSrc] = useState(videos[0]);
  const [mediaType, setMediaType] = useState('video');
  const [mediaIndex, setMediaIndex] = useState('media-0');
  const [loadErrorArray, setLoadErrorArray] = useState([]);
  const _onImageClick = (imageSrc) => {
    setMediaType('image');
    setMain(imageSrc)
  }

  const _onVideoClick = (videoSrc) => {
    setMediaType('video');
    setMain('');
    setCurrentVideoSrc(videoSrc)
  }
  
  const _renderImages = () => {
    return images.map((imageSrc, index) => {
      return <div
        key={index}
        className='pointer round-8'
        onClick={() => _onImageClick(imageSrc)}
        style={{ backgroundImage:  `url(`+imageSrc+`)`, width: '100%', height: '100%', backgroundSize: 'cover' }}>
      </div>
    })
  }

  const _renderVideos = () => {
    return videos.map((videoSrc, index) => {
      return <VegaFlex
        key={index}
        justifyContent={'center'}
        alignItems={'center'}
        id={`video-${index}`}
        className='pointer round-8 relative'
        onClick={() => _onVideoClick(videoSrc)}
        style={{ width: '100%', height: '100%', overflow: 'hidden'}}>
        <div className={'absolute w-full h-full top-floor'}></div>
        {
          loadErrorArray.includes('video-' + index) && <VegaFlex direction={'col'} justifyContent={'center'} alignItems={'center'}>
            <VegaIcon icon="fa-solid fa-ban" size="size-48"></VegaIcon>
            <p>Only Youtube Video is supported</p>
          </VegaFlex>
        }
        {
          !loadErrorArray.includes('video-' + index) && <ReactPlayer
            src={videoSrc}
            style={{ width: '100%', height: '100%' }}
            playing={false}
            onStart={e => e.preventDefault()}
            onError={() => setLoadErrorArray([...loadErrorArray, 'video-' + index])}
          />
        }

      </VegaFlex>
    })
  }

  const _renderMedia = () => {
    const videos = _renderVideos();
    const images = _renderImages();
    const assembled = [...videos, ...images];
    return assembled.map((m, index) => (
      <div
        style={{ height: '30%', marginBottom: 16, marginLeft: 5, marginRight: 5, borderRadius: 8, border: mediaIndex === `media-${index}` ? '2px solid #1362E2' : '', boxShadow: mediaIndex === `media-${index}` ? '0 0 0 4px rgba(19, 98, 226, 0.25)' : ''}}
        key={index}
        onClick={() => onMediaClick(index)}
        className='pointer round-8'
      >
        {m}
      </div>
    ))
  }

  useEffect(() => {
    if(videos.length > 0) {
      setCurrentVideoSrc(videos[0]);
      setMediaType('video');
    } else {
      setMain(images[0]);
      setMediaType('image');
    }
  }, [videos, videos.length, images, images.length]);

  const onMediaClick = (index) => {
    setMediaIndex(`media-${index}`);
  }

  return (
    <VegaFlex direction={direction} className='w-full' gap={(videos.length < 1 && images.length < 1) ? 'size-0' : 'size-16'}>
      <div className='round-16' style={{ height, width: '100%', backgroundImage: `url(`+ main +`)`, backgroundSize: 'cover' }}>
        {
          mediaType === 'video' && <ReactPlayer
            src={currentVideoSrc}
            style={{ width: '100%', height: '100%' }}
            playing={false}
            controls={true}
          />
        }
      </div>
      <div style={{ height, width: (videos.length < 1 && images.length < 1) ? '0%' : '25%', overflowY: 'scroll', paddingTop: 4 }}>
        {_renderMedia()}
      </div>
    </VegaFlex>
  );
}

export default Carousel;
